import React from 'react'
import { useTranslation } from 'react-i18next';

const FeaturesList = () => {
  const { t } = useTranslation();
  const features = [
    {
      name: t("RAL0838"),
      feature_code: "MEMBER_COUNT",
      defaultValue: "Member count",
      currentValue:"0"
    },
    {
      name: t("RAL0839"),
      feature_code: "PROJECT_COUNT",
      defaultValue: "Project count",
      currentValue:"0"
    },
    {
      name: t("RAL0960"),
      feature_code: "TAG_COUNT",
      defaultValue: "tag count",
      currentValue:"0"
    },
    {
      name: t("RAL0842"),
      feature_code: "DAILY_AI_SUMMARIZATION_LIMITS",
      defaultValue: "Daily AI summerization per user",
      currentValue:"0"
    },
    {
      name: t("RAL0840"),
      feature_code: "TIMESHEET",
      defaultValue: "Automatic project tagging",
      currentValue:false
    },
    {
      name: t("RAL0841"),
      feature_code: "OTHERS",
      defaultValue: "Multi Language Support",
      currentValue:false
    },
    // {
    //   name: t("RAL0869"),
    //   feature_code: "AI_TIME_CATEGORISATION",
    //   defaultValue:"",
    //   currentValue:""
    // },
   
    {
      name: t("RAL0870"),
      feature_code: "TIMESHEET",
      defaultValue: "In-App Chatbot Support",
      currentValue:false
    },
    {
      name: t("RAL0843"),
      feature_code: "INTEGRATION",
      defaultValue: "Biotime",
      currentValue:false
    },
    {
      name: t("RAL0973"),
      feature_code: "REPORT",
      defaultValue: "Export",
      currentValue:false
    },
    // {
    //   name: t("RAL0871"),
    //   feature_code: "API_ACCESS",
    //   defaultValue:"",
    //   currentValue:false
    // },
    {
      name: t("RAL0872"),
      feature_code: "OTHERS",
      defaultValue: "Team lead",
      currentValue:false
    },
    {
      name: t("RAL0844"),
      feature_code: "DASHBOARD",
      defaultValue: "Members Dashboard",
      currentValue:false
    },
    {
      name: t("RAL0845"),
      feature_code: "DASHBOARD",
      defaultValue: "Organization Dashboard",
      currentValue:false
    }
  ]
  return { features };
}

export default FeaturesList
